import { render, staticRenderFns } from "./Concessionary.vue?vue&type=template&id=20daaf59"
import script from "./Concessionary.vue?vue&type=script&lang=js"
export * from "./Concessionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports